import { render, staticRenderFns } from "./_Navigation.vue?vue&type=template&id=46b80c4f&"
import script from "./_Navigation.vue?vue&type=script&lang=js&"
export * from "./_Navigation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports